export enum HttpStatusCode {
	Continue = 100,
	SwitchingProtocols = 101,
	EarlyHints = 103,

	Ok = 200,
	Created = 201,
	Accepted = 202,
	NonAuthoritativeInformation = 203,
	NoContent = 204,
	ResetContent = 205,
	PartialContent = 206,

	MultipleChoices = 300,
	MovedPermanently = 301,
	Found = 302,
	SeeOther = 303,
	NotModified = 304,
	TemporaryRedirect = 307,
	PermanentRedirect = 308,

	BadRequest = 400,
	Unauthorized = 401,
	PaymentRequired = 402,
	Forbidden = 403,
	NotFound = 404,
	MethodNotAllowed = 405,
	NotAcceptable = 406,
	RequestTimeout = 408,
	Conflict = 409,
	Gone = 410,
	PreconditionFailed = 412,
	ContentTooLarge = 413,
	UriTooLong = 414,
	UnsupportedMediaType = 415,
	TooManyRequests = 429,

	InternalServerError = 500,
	NotImplemented = 501,
	BadGateway = 502,
	ServiceUnavailable = 503,
	GatewayTimeout = 504,
	NetworkAuthenticationRequired = 511,
}
